import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Button from 'components/shared/Button/Button';
import Modal from 'components/shared/Modal';

type ModalFilter = {
  hide?: boolean;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
};

type CollectionsModalProps = {
  title: string;
  buttons: JSX.Element;
  lastFocusedElementId: string;
  filter?: ModalFilter;
  children: JSX.Element;
  onClose: () => void;
};

function ModalFilter(props: ModalFilter) {
  const { onChange, value, placeholder, hide } = props;

  const showClearButton = useMemo(() => value !== '', [value]);

  function clearSearchField() {
    onChange('');
  }

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { target } = e;
    onChange(target.value);
  }

  if (hide) return null;

  return (
    <React.Fragment>
      <label htmlFor="collection-modal-filter" className="screen-reader-text">
        {placeholder || 'Find...'}
      </label>
      <input
        id="collection-modal-filter"
        className="modal-filter"
        onChange={handleChange}
        placeholder={placeholder || 'Find...'}
        value={value}
      />
      {showClearButton && (
        <Button
          type="icon"
          icon="times-circle"
          className="clear_search_button"
          a11yText="clear search field"
          onClick={clearSearchField}
        />
      )}
      <FontAwesomeIcon icon="search" />
    </React.Fragment>
  );
}

function CollectionsModal(props: CollectionsModalProps) {
  const { title, buttons, lastFocusedElementId, filter, onClose, children } = props;

  const secondaryFooterGroup = filter ? <ModalFilter {...filter} /> : null;

  return (
    <Modal
      title={title}
      labelledBy="collections-manager-modal"
      lastFocusedElementId={lastFocusedElementId}
      onClose={onClose}
      modalClass={['collections-manager']}
      primaryFooterGroup={buttons}
      secondaryFooterGroup={secondaryFooterGroup}
    >
      <div className="collections_manager_modal">
        <div className={`collections_manager_container`}>{children}</div>
      </div>
    </Modal>
  );
}

export default CollectionsModal;
